export const CREDITS_PILL_TOOLTIP_Z_INDEX = 10001;

export interface CreditsPillContent {
	visible: boolean;
	remainingCredits: number;
	actionCost: number;
	showPremiumIcon?: boolean;
}